import {
  ActionBar,
  ActionBarButtons,
  Column,
  CreateActionButton,
  htmlFormat,
  htmlSpan,
  List,
  Row,
  useApi,
  useFlipperQuery,
} from "lcm-iot-commons";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { extractEdgeDevices } from "../../extractors/edgeDevicesExtractor";
import EdgeDeviceItem from "../EdgeDevice/EdgeDeviceItem";
import {
  edgeDeviceShape,
  edgeDevicesShape,
} from "../../shapes/edgeDevicesShape";
import { connectSubscriptionAddOnShape } from "../../shapes/connectSubscriptionsShape";

type Props = Readonly<{
  canUpdateClientApplication?: boolean;
}>;

export default function ConnectSubscriptionEdgeDevices(props: Props) {
  const api = useApi();
  const intl = useIntl();
  const { data: flipper } = useFlipperQuery();
  const { id: subscriptionId } = useParams<{ id: string }>();

  const { canUpdateClientApplication } = props;
  const targetUrl = `/edge_devices/create`;

  const [edgeDevices, setEdgeDevices] = useState<edgeDevicesShape>([]);

  const { data: edgeDevicesResponse } = api.get.useQuery(
    `/api_subscriptions/${subscriptionId}/edge_devices`,
    { order_by: "name", include: "status,type" },
    {
      select: extractEdgeDevices,
    },
  );
  const { data: numberOfFreeUplinks, refetch } = api.get.useQuery(
    `/api_subscriptions/${subscriptionId}/add_ons`,
    { add_on_type: "connectivity", product_code: "uplink" },
    {
      enabled: !!flipper?.edgeDeviceCreateNni,
      select: ({
        add_ons: addOns,
      }: {
        add_ons: connectSubscriptionAddOnShape[];
      }) => {
        const addOn = addOns?.[0];
        return addOn ? addOn.quantity - addOn.assigned_edge_devices_count : 0;
      },
    },
  );

  useEffect(() => {
    if (edgeDevicesResponse?.length) setEdgeDevices(edgeDevicesResponse);
  }, [edgeDevicesResponse]);

  const actionBarButtons = (
    <ActionBarButtons>
      <CreateActionButton
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; disabled: bool... Remove this comment to see the full error message
        id="create-edge-device-button"
        target={targetUrl}
        disabled={!canUpdateClientApplication || numberOfFreeUplinks === 0}
      />
    </ActionBarButtons>
  );

  const informationFreeAddons = (
    <div className="edge-free-uplink-addons-align">
      <FormattedMessage
        id="edge_device.number_free_addons"
        values={{
          ...htmlFormat,
          numberOfUplinks: numberOfFreeUplinks,
          // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
          span: htmlSpan({ className: "edge-free-uplink-addons" }),
        }}
      />
    </div>
  );

  const onEdgeDeviceRemove = async (edgeDevice: edgeDeviceShape) => {
    setEdgeDevices(edgeDevices.filter((ed) => ed.id !== edgeDevice.id));
    await refetch();
  };

  return (
    <>
      <Row id="subscription-edge-devices">
        <Column>
          <ActionBar>
            <h2>
              <FormattedMessage id="edge_devices.header" />
            </h2>
            {flipper?.edgeDeviceCreateNni ? actionBarButtons : null}
          </ActionBar>
        </Column>
      </Row>
      {flipper?.edgeDeviceCreateNni ? informationFreeAddons : null}
      {edgeDevices?.length > 0 ? (
        // @ts-expect-error TS(2322) FIXME: Type '{ children: any; id: string; className: stri... Remove this comment to see the full error message
        <List id="edge-device-item-list" className="list">
          {edgeDevices.map((edgeDevice) => (
            <EdgeDeviceItem
              key={edgeDevice.id}
              edgeDevice={edgeDevice}
              intl={intl}
              showItemMenu
              showDelete
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; edgeDevice: any; intl: intlShape | undefined; showItemMenu: true; sho... Remove this comment to see the full error message
              flipper={flipper}
              onEdgeDeviceRemove={onEdgeDeviceRemove}
            />
          ))}
        </List>
      ) : (
        <FormattedMessage id="subscription.no_edgedevices_assign" />
      )}
    </>
  );
}
